export default __webpack_public_path__ + "static/font-e48f3f45bc352f3204ec150dd325d3b7.woff2";